document.addEventListener("DOMContentLoaded", function () {
  /* =============================
     ELEMENTS
  ============================= */
  const dateInput = document.getElementById("calendarDate");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");
  const headerText = document.getElementById("pd-hero-date");
  const cityInput = document.getElementById("birthCity");
  const suggestionBox = document.getElementById("locationSuggestions");
  const cityLoader = document.getElementById("cityLoader");
  const proxyUrl = window.__GUIDEGURU_PROXY_URL || '/apps/guideguru';

  // Default Coordinates (New Delhi)
  const DEFAULT_LAT = "28.644800";
  const DEFAULT_LON = "77.216721";

  document.getElementById("latitude").value = DEFAULT_LAT;
  document.getElementById("longitude").value = DEFAULT_LON;

  /* =============================
     DATE FUNCTIONS
  ============================= */
  function formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function formatFullDate(dateString) {
    const dateObj = new Date(dateString);
    const options = {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    };
    return dateObj.toLocaleDateString('en-GB', options);
  }

  function updateHeader(dateString) {
    if (headerText) {
      headerText.textContent = "Panchang For " + formatFullDate(dateString);
    }
  }

  /* =============================
     FETCH PANCHANG
  ============================= */
  function fetchPanchang(date) {
    const lat = document.getElementById("latitude").value;
    const lon = document.getElementById("longitude").value;

    // SHOW LOADER
    const loader = document.getElementById("panchangLoader");
    if (loader) loader.classList.add("active");

    const fetchUrl = `${proxyUrl}/api/panchang?date=${encodeURIComponent(date)}&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`;

    fetch(fetchUrl)
      .then(res => res.json())
      .then(json => {
        // HIDE LOADER
        if (loader) loader.classList.remove("active");

        if (!json.ok || !json.data) {
          console.error("Invalid Panchang Response");
          return;
        }
        const data = json.data;

        document.getElementById("sunrise_data").innerText = data.sunrise || '-';
        document.getElementById("sunset_data").innerText = data.sunset || '-';
        document.getElementById("moonrise_data").innerText = data.moonrise || '-';
        document.getElementById("moonset_data").innerText = data.moonset || '-';
        document.getElementById("vedic_sunrise_data").innerText = data.vedic_sunrise || '-';
        document.getElementById("vedic_sunset_data").innerText = data.vedic_sunset || '-';

        if(data.tithi && data.tithi.details) {
          let tithi = data.tithi.details;
          let tithi_end = data.tithi.end_time || {hour: '-', minute: '-'};
          document.getElementById("tithi_name").innerText = tithi.tithi_name || '-';
          document.getElementById("tithi_number").innerText = tithi.tithi_number || '-';
          document.getElementById("tithi_special").innerText = tithi.special || '-';
          document.getElementById("tithi_deity").innerText = tithi.deity || '-';
          document.getElementById("tithi_summary").innerText = tithi.summary || '-';
          document.getElementById("tithi_end_time").innerText = tithi_end.hour + ':' + tithi_end.minute;
        }

        if(data.nakshatra && data.nakshatra.details) {
          let nakshatra = data.nakshatra.details;
          let nakshatra_end = data.nakshatra.end_time || {hour: '-', minute: '-'};
          document.getElementById("nak_name").innerText = nakshatra.nak_name || '-';
          document.getElementById("nak_number").innerText = nakshatra.nak_number || '-';
          document.getElementById("nak_deity").innerText = nakshatra.deity || '-';
          document.getElementById("nak_ruler").innerText = nakshatra.ruler || '-';
          document.getElementById("nak_special").innerText = nakshatra.special || '-';
          document.getElementById("nak_summary").innerText = nakshatra.summary || '-';
          document.getElementById("nak_end_time").innerText = nakshatra_end.hour + ':' + nakshatra_end.minute;
        }

        if(data.yog && data.yog.details) {
          let yog = data.yog.details;
          let yog_end = data.yog.end_time || {hour: '-', minute: '-'};
          document.getElementById("yog_name").innerText = yog.yog_name || '-';
          document.getElementById("yog_number").innerText = yog.yog_number || '-';
          document.getElementById("yog_special").innerText = yog.special || '-';
          document.getElementById("yog_meaning").innerText = yog.meaning || '-';
          document.getElementById("yog_end_time").innerText = yog_end.hour + ':' + yog_end.minute;
        }

        if(data.karan && data.karan.details) {
          let karan = data.karan.details;
          let karan_end = data.karan.end_time || {hour: '-', minute: '-'};
          document.getElementById("karan_name").innerText = karan.karan_name || '-';
          document.getElementById("karan_number").innerText = karan.karan_number || '-';
          document.getElementById("karan_special").innerText = karan.special || '-';
          document.getElementById("karan_deity").innerText = karan.deity || '-';
          document.getElementById("karan_end_time").innerText = karan_end.hour + ':' + karan_end.minute;
        }

        document.getElementById("vikram_samvat").innerText = data.vikram_samvat || '-';
        document.getElementById("vkram_samvat_name").innerText = data.vkram_samvat_name || '-';
        document.getElementById("shaka_samvat").innerText = data.shaka_samvat || '-';
        document.getElementById("shaka_samvat_name").innerText = data.shaka_samvat_name || '-';
        document.getElementById("paksha").innerText = data.paksha || '-';
        document.getElementById("ayana").innerText = data.ayana || '-';
        document.getElementById("sun_sign").innerText = data.sun_sign || '-';
        document.getElementById("moon_sign").innerText = data.moon_sign || '-';

        if(data.abhijit_muhurta) {
          document.getElementById("abhijit_muhurta_start").innerText = data.abhijit_muhurta.start || '-';
          document.getElementById("abhijit_muhurta_end").innerText = data.abhijit_muhurta.end || '-';
        }
        document.getElementById("panchang_yog").innerText = data.panchang_yog || '-';
        
        if(data.rahukaal) {
          document.getElementById("rahukaal_start").innerText = data.rahukaal.start || '-';
          document.getElementById("rahukaal_end").innerText = data.rahukaal.end || '-';
        }
        if(data.guliKaal) {
          document.getElementById("gulik_kaal_start").innerText = data.guliKaal.start || '-';
          document.getElementById("gulik_kaal_end").innerText = data.guliKaal.end || '-';
        }
        if(data.yamghant_kaal) {
          document.getElementById("yamghant_kaal_start").innerText = data.yamghant_kaal.start || '-';
          document.getElementById("yamghant_kaal_end").innerText = data.yamghant_kaal.end || '-';
        }
        
        document.getElementById("disha_shool").innerText = data.disha_shool || '-';
        if(data.nak_shool) document.getElementById("nak_shool").innerText = data.nak_shool.direction || '-';
        document.getElementById("moon_nivas").innerText = data.moon_nivas || '-';

        // Zodiac Images
        if(data.sun_sign && data.moon_sign) {
          let sunSignStr = data.sun_sign.toLowerCase();
          let moonSignStr = data.moon_sign.toLowerCase();
          let baseURL = "https://cdn.shopify.com/s/files/1/0732/4637/6250/files/";
          document.getElementById("sun_sign_img").src = baseURL + sunSignStr + "_zodiac_sign_image_06.webp";
          document.getElementById("moon_sign_img").src = baseURL + moonSignStr + "_zodiac_sign_image_06.webp";

          renderZodiac(sunSignStr, moonSignStr);
        }
      })
      .catch(err => {
        if (loader) loader.classList.remove("active");
        console.error("Fetch Error:", err);
      });
  }

  /* =============================
     ZODIAC PRODUCTS LOGIC
  ============================= */
  async function getProducts(handle) {
    try {
      const r = await fetch(`/collections/${handle}/products.json`);
      if (!r.ok) return [];
      const j = await r.json();
      let products = j.products || [];
      products = products.filter(p => p.variants?.some(v => v.available));
      return products;
    } catch(e) {
      console.warn("Could not fetch collection:", handle);
      return [];
    }
  }

  function formatPrice(price) { return "₹ " + price; }

  function createProductCard(p) {
    const img = p.images?.[0]?.src || "";
    const v = p.variants?.[0];
    if (!v) return "";
    const price = formatPrice(v.price);
    return `
      <div class="gg-pd-product-card">
        <a href="/products/${p.handle}" style="text-decoration:none; color:inherit;">
          <img src="${img}" class="gg-pd-product-img">
          <h4 class="gg-pd-product-title">${p.title}</h4>
        </a>
        <p class="gg-pd-product-price">${price}</p>
        <div class="gg-pd-product-actions">
          <form method="post" action="/cart/add">
            <input type="hidden" name="id" value="${v.id}">
            <button type="submit" class="button button--secondary">Add to Cart</button>
          </form>
          <a href="/cart/${v.id}:1" class="button button--primary">Buy Now</a>
        </div>
      </div>
    `;
  }

  async function renderZodiac(sunSign, moonSign) {
    const zodiacContainer = document.getElementById("zodiacProducts");
    if (!zodiacContainer) return;
    
    let cleanSun = sunSign.replace(/\s+/g,'').toLowerCase();
    let cleanMoon = moonSign.replace(/\s+/g,'').toLowerCase();
    let suffix = "-zodiac-sign";
    let sunHandle = cleanSun + suffix;
    let moonHandle = cleanMoon + suffix;

    zodiacContainer.innerHTML = "<p style='text-align:center;padding:20px;'>Loading zodiac products...</p>";

    if (sunHandle === moonHandle) {
      const products = await getProducts(sunHandle);
      if(products.length === 0) { zodiacContainer.innerHTML = ''; return; }
      zodiacContainer.innerHTML = `
        <div class="gg-pd-zodiac-section">
          <h2>Your Zodiac Products</h2>
          <div class="gg-pd-zodiac-products-grid">${products.map(createProductCard).join("")}</div>
        </div>
      `;
    } else {
      const sunProducts = await getProducts(sunHandle);
      const moonProducts = await getProducts(moonHandle);
      
      let html = '';
      if(sunProducts.length > 0) {
        html += `
          <div class="gg-pd-zodiac-section">
            <h2>Sun Sign Products</h2>
            <div class="gg-pd-zodiac-products-grid">${sunProducts.map(createProductCard).join("")}</div>
          </div>
        `;
      }
      if(moonProducts.length > 0) {
        html += `
          <div class="gg-pd-zodiac-section">
            <h2>Moon Sign Products</h2>
            <div class="gg-pd-zodiac-products-grid">${moonProducts.map(createProductCard).join("")}</div>
          </div>
        `;
      }
      zodiacContainer.innerHTML = html;
    }
  }

  /* =============================
     AUTO-LOCATION INIT
  ============================= */
  function initGeolocation() {
    const initialDate = dateInput.value || formatDate(new Date());
    if (!dateInput.value) dateInput.value = initialDate;
    updateHeader(initialDate);
    
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          document.getElementById("latitude").value = pos.coords.latitude.toFixed(6);
          document.getElementById("longitude").value = pos.coords.longitude.toFixed(6);
          fetchPanchang(initialDate);
        },
        () => {
          fetchPanchang(initialDate);
        },
        { timeout: 5000, maximumAge: 300000 }
      );
    } else {
      fetchPanchang(initialDate);
    }
  }

  /* =============================
     EVENT LISTENERS
  ============================= */
  if (dateInput) {
    initGeolocation();

    dateInput.addEventListener("change", function() {
      if(this.value) {
        updateHeader(this.value);
        fetchPanchang(this.value);
      }
    });

    prevBtn?.addEventListener("click", function () {
      let d = new Date(dateInput.value);
      d.setDate(d.getDate() - 1);
      const newDate = formatDate(d);
      dateInput.value = newDate;
      updateHeader(newDate);
      fetchPanchang(newDate);
    });

    nextBtn?.addEventListener("click", function () {
      let d = new Date(dateInput.value);
      d.setDate(d.getDate() + 1);
      const newDate = formatDate(d);
      dateInput.value = newDate;
      updateHeader(newDate);
      fetchPanchang(newDate);
    });
  }

  /* =============================
     CITY AUTOCOMPLETE
  ============================= */
  let debounceTimer;
  if (cityInput) {
    cityInput.addEventListener("input", function () {
      clearTimeout(debounceTimer);
      const query = this.value.trim();
      
      if (query.length < 3) {
        suggestionBox.style.display = "none";
        return;
      }

      cityLoader.style.display = "block";
      
      debounceTimer = setTimeout(() => {
        fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`)
          .then(response => response.json())
          .then(data => {
            cityLoader.style.display = "none";
            suggestionBox.innerHTML = "";
            
            if (data.length > 0) {
              data.forEach(place => {
                const li = document.createElement("li");
                // Create a simplified display name
                const parts = place.display_name.split(',');
                li.textContent = parts.slice(0, 3).join(', '); 
                li.addEventListener("click", () => {
                  cityInput.value = li.textContent;
                  document.getElementById("latitude").value = place.lat;
                  document.getElementById("longitude").value = place.lon;
                  suggestionBox.style.display = "none";
                  
                  // Trigger fetch with new location
                  if (dateInput.value) {
                    fetchPanchang(dateInput.value);
                  }
                });
                suggestionBox.appendChild(li);
              });
              suggestionBox.style.display = "block";
            } else {
              suggestionBox.style.display = "none";
            }
          })
          .catch(() => {
            cityLoader.style.display = "none";
          });
      }, 500);
    });

    // Hide suggestions on outside click
    document.addEventListener("click", function(e) {
      if(!cityInput.contains(e.target) && !suggestionBox.contains(e.target)) {
        suggestionBox.style.display = "none";
      }
    });
  }
});
